<template>
  <div data-role="qc-pagination" class="tc-15-page">
    <!-- 分页器状态 -->
    <div class="tc-15-page-state">
      <span class="tc-15-page-text">
        <template>
          {{ $t('core.pagination.checked') }}
          <strong>{{ selectedNum }}</strong>
          {{ selectedNum > 1 ? $t('core.pagination.items') : $t('core.pagination.item') }},
          <span v-html="$t('core.pagination.itemPulled',{num:totalNum})"></span>
        </template>

      </span>
    </div>
    <div class="tc-15-page-operate">
      <span class="tc-15-page-text">{{ $t('core.pagination.linesPerPage') }}</span>
      <!-- 页数大小选择 -->
      <div :class="{ 'tc-15-page-selected': pageSizeShow }" class="tc-15-page-select"
        v-click-outside="onPageSizeSelectClickOutside">
        <qc-button type="text" class="indent" style="line-height: 1" @click="onClickTrigger">
          {{ innerPageSize }}
          <span class="ico-arrow" />
        </qc-button>
        <ul v-if="pageSizeShow" class="tc-15-simulate-option tc-15-def-scroll">
          <li v-for="pageSizeOption in pageSizeOptions" :key="pageSizeOption" @click="onSelectPageSize(pageSizeOption)">
            {{ pageSizeOption }}</li>
        </ul>
      </div>
      <!-- 选项前一页 -->
      <qc-button :class="{'disable': disableBackward }" :disabled="disableBackward"
        title="$t('core.pagination.previousPage')" class="tc-15-page-pre" type="text"
        @click="onSelectPage(innerCurrPage - 1)" />
      <!--  页码选择 -->
      <div class="tc-15-page-select" :class="{ 'tc-15-page-selected': pageShow }">
        <a class="tc-15-page-num" href="javascript:;" @click="onSeletePage">
          {{$t('core.pagination.pageIndex',{index: innerCurrPage})}}</a>
        <ul v-if="pageShow" v-click-outside="onPageSelectClickOutside" class="tc-15-simulate-option tc-15-def-scroll">
          <li v-for="pageOption in pageOptions" :key="pageOption" @click="onSelectPage(pageOption + 1)">
            {{ $t('core.pagination.pageIndex',{index: pageOption+1}) }}
          </li>
          <li v-if="hasMore" @click="onSelectPage(lastPage + 1)">
            {{ $t('qc.pagination.nextPage') }}
          </li>
        </ul>
      </div>
      <!-- 选项后一页 -->
      <qc-button :class="{'disable': disableForward}" :disabled="disableForward" title="$t('qc.pagination.nextPage')"
        class="tc-15-page-next" type="text" @click="onSelectPage(innerCurrPage + 1)" />
    </div>
  </div>
</template>

<script>
import clickOutside from '@/scripts/directives/clickOutside';

export default {
  directives: {
    clickOutside,
  },
  props: {
    /**
     * 总数
     */
    totalNum: {
      type: [Number, String],
      default: 0,
    },
    /**
     * 当前页码
     */
    currPage: {
      type: Number,
      default: 1,
    },
    /**
     * 每页的条数
     */
    pageSize: {
      type: Number,
      default: 100,
    },
    /**
     * 已选择项数
     */
    selectedNum: {
      type: Number,
      default: 0,
    },
    /**
     * 是否还有更多页码
     */
    hasMore: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerCurrPage: this.currPage,
      pageSizeShow: false,
      pageShow: false, // 展示选择当前页列表
      innerPageSize: this.pageSize,
      pageSizeOptions: [50, 100, 200],
    };
  },
  watch: {
    currPage() {
      this.innerCurrPage = this.currPage;
    },
    pageSize() {
      this.innerPageSize = this.pageSize;
    },
  },
  computed: {
    lastPage() {
      return Math.ceil(this.totalNum / this.innerPageSize);
    },
    pageOptions() {
      // 这里的索引从 0 开始
      const options = [...Array(this.lastPage).keys()];
      return options;
    },
    // 把类似9999+转换成10000
    originTotalNum() {
      const num = Number.isInteger(this.totalNum)
        ? this.totalNum
        : parseInt(this.totalNum, 10) + 1;
      return num;
    },
    disableBackward() {
      return this.innerCurrPage <= 1;
    },
    disableForward() {
      return this.innerCurrPage >= this.lastPage;
    },
    /**
     * 用于拦截对 innerCurrPage 的改变并触发事件的代理
     */
    innerCurrPageProxy: {
      get() {
        return this.innerCurrPage;
      },
      set(currPage) {
        if (currPage !== this.innerCurrPage) {
          this.innerCurrPage = currPage;
          /**
           * 统一改动事件
           * @event change
           */
          this.$emit('change', { currPage, pageSize: this.innerPageSize });
        }
      },
    },
    /**
     * 用于拦截对 pageSize 的改变并触发事件的代理
     */
    innerPageSizeProxy: {
      get() {
        return this.innerPageSize;
      },
      set(pageSize) {
        if (pageSize !== this.innerPageSize) {
          this.innerPageSize = pageSize;
          // 每页显示数量改变时，计算一个合适的 currPage
          const properCurrPage = this.getProperCurrPage(
            this.totalNum,
            pageSize,
            this.innerCurrPage,
          );

          // 直接改动 innerCurrPage, 不触发事件
          this.innerCurrPage = properCurrPage;
          /**
           * 统一改动事件
           * @event change
           */
          this.$emit('change', { currPage: properCurrPage, pageSize });
        }
      },
    },
  },
  methods: {
    /**
     * 计算合适的 currPage
     * @param {number} totalNum
     * @param {number} pageSize
     * @param {number} currPage
     */
    getProperCurrPage(totalNum, pageSize, currPage) {
      // 下界为 1
      // 上界为 totalNum / pageSize
      return Math.max(Math.min(Math.ceil(totalNum / pageSize), currPage), 1);
    },
    onSelectPage(currPage) {
      this.innerCurrPageProxy = currPage;
      this.pageShow = false;
    },
    onClickTrigger() {
      this.pageSizeShow = true;
    },
    onSeletePageSize() {
      this.pageSizeShow = true;
    },
    onSeletePage() {
      this.pageShow = true;
    },
    onPageSizeSelectClickOutside() {
      if (this.pageSizeShow) this.pageSizeShow = false;
    },
    onPageSelectClickOutside() {
      if (this.pageShow) this.pageShow = false;
    },
    onSelectPageSize(pageSize) {
      this.innerPageSizeProxy = pageSize;
      this.pageSizeShow = false;
    },
  },
};
</script>

<style scoped>
.tc-15-page-pre {
  margin-left: 10px;
}
.tc-15-page {
  max-width: unset;
}
</style>
